import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface CourierOption {
  value: string;
  count: number;
}

/**
 * Distinct courier services present in orders, for the courier filter dropdown.
 */
export function useCouriers() {
  return useQuery({
    queryKey: ["order-couriers"],
    queryFn: async (): Promise<CourierOption[]> => {
      const { data, error } = await apiClient.GET("/v1/orders/couriers", {});
      if (error) throw error;
      return data?.data ?? [];
    },
    staleTime: 5 * 60_000,
  });
}
